var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "global-static-cards", attrs: { id: "GlobalStatsCard" } },
    [
      _c("base-card", {
        attrs: {
          "id-tag": _vm.cardName,
          title: _vm.title,
          "card-type": !_vm.cardName ? "nonpinnable" : "pinnable",
          "module-icon": _vm.gsHeaderIcon,
          "display-order": _vm.displayOrder,
          "api-endpoints": _vm.apiEndpoints,
          "user-guide-identifier": _vm.userGuideIdentifier
        },
        on: {
          MoveCardUp: function($event) {
            return _vm.$emit("MoveCardUp", _vm.displayOrder)
          },
          MoveCardDown: function($event) {
            return _vm.$emit("MoveCardDown", _vm.displayOrder)
          }
        },
        scopedSlots: _vm._u(
          [
            _vm.identityMapId
              ? {
                  key: "config",
                  fn: function() {
                    return [
                      _c("identity-map-link", {
                        staticClass: "ml-2",
                        attrs: {
                          id: _vm.identityMapId,
                          mode: _vm.identityMapMode,
                          "focal-name": _vm.identityMapName,
                          "focal-type": _vm.identityMapFocalType
                        }
                      })
                    ]
                  },
                  proxy: true
                }
              : null,
            _vm.$slots["after-title"]
              ? {
                  key: "after-title",
                  fn: function() {
                    return [_vm._t("after-title")]
                  },
                  proxy: true
                }
              : null,
            {
              key: "chart",
              fn: function() {
                return [
                  _c(
                    "v-layout",
                    { staticClass: "UDM_GS_Count_Row", attrs: { row: "" } },
                    _vm._l(_vm.sanitizedStatsGroups, function(
                      groupProps,
                      groupLabel
                    ) {
                      return _c(
                        "v-flex",
                        { key: groupLabel, staticClass: "global-stats-group" },
                        [
                          _vm._t("above-stats"),
                          _vm._v(" "),
                          _c(
                            "header",
                            {
                              class: [
                                "text-center subheading",
                                groupLabel ? "pt-2" : ""
                              ]
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(groupLabel) +
                                  "\n          "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            { attrs: { row: "" } },
                            _vm._l(groupProps, function(prop) {
                              return _c(
                                "v-flex",
                                {
                                  key: prop,
                                  staticClass: "pa-3 global-stats-flex",
                                  on: {
                                    mouseenter: function($event) {
                                      return _vm.emitHoverEvent(prop)
                                    }
                                  }
                                },
                                [
                                  _vm._t(
                                    prop + "-card",
                                    [
                                      !_vm.hideGsPropName
                                        ? _c(
                                            "p",
                                            {
                                              staticClass:
                                                "subheading text-xs-center mb-0",
                                              attrs: {
                                                id: "SB_GS_Label_" + prop
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.rename[prop] || prop
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.globalStatsLink
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "subheading text-xs-center font-weight-bold"
                                            },
                                            [
                                              _c(
                                                "h2",
                                                [
                                                  _c(
                                                    "router-link",
                                                    {
                                                      attrs: {
                                                        id: "SB_GS_" + prop,
                                                        to:
                                                          _vm.globalStats[prop]
                                                            .link
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm.globalStats[
                                                              prop
                                                            ].text
                                                          ) +
                                                          "\n                    "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "subheading text-xs-center"
                                            },
                                            [
                                              _vm._t(
                                                prop + "-body",
                                                [
                                                  _c(
                                                    "h2",
                                                    {
                                                      staticClass: "mb-0",
                                                      attrs: {
                                                        id: "SB_GS_" + prop
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm.formatStatValue(
                                                              _vm.globalStats[
                                                                prop
                                                              ]
                                                            )
                                                          ) +
                                                          "\n                    "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                { value: _vm.globalStats[prop] }
                                              )
                                            ],
                                            2
                                          )
                                    ],
                                    {
                                      value: _vm.globalStats[prop],
                                      cardName: _vm.rename[prop] || prop
                                    }
                                  )
                                ],
                                2
                              )
                            }),
                            1
                          )
                        ],
                        2
                      )
                    }),
                    1
                  )
                ]
              },
              proxy: true
            }
          ],
          null,
          true
        )
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }